import { apiRequest } from "./common";

const getAnalytics = async () => {
    const response = await apiRequest('get', '/student/analytics/performance-insight');
    return response.data;
};

const getExamData = async (testType) => {
    const response = await apiRequest('get', `/test/${testType}/analytics`);
    return response.data;
};

const getMileStoneTest = async () => {
    const response = await apiRequest('get', `/student/upcoming-task-milestone-test`);
    return response.data;   
};

const getCounsellingTask = async () => {
    const response = await apiRequest('get', `/task/task-counseling-tracker`);
    return response.data;   
};

const getProjectAnalytics = async () => {
    const response = await apiRequest('get', `/project/performance-analytics`);
    return response.data;   
};

const getAcademicAnalytics = async (serviceType, semester, studentSubjectId) => {
    const response = await apiRequest('get', `/student-score/score-analytics/${serviceType}?${semester ? `semester=${semester}` : ''}${studentSubjectId ? `studentSubjectId=${studentSubjectId}` : ''}`);
    return response.data;   
};

export {
    getAnalytics,
    getExamData,
    getMileStoneTest,
    getCounsellingTask,
    getProjectAnalytics,
    getAcademicAnalytics
}